export const CLIENT_ID = 'eyJhbGciOiJIUzI1NiJ9.ZDEyMTdhOWEtN2QxMS00ZTBmLWIyNzctMGE4ZWUwN2M2NzQx.JWXkCOUIagc4dnrJL37lKXGqbCSBFtKdv-ktfcvCPs8';
//# sourceMappingURL=constants.js.map